<script setup>
import { defineProps, computed } from 'vue';
import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoTextoBase from '@/components/v2/base/CampoTextoBase/CampoTextoBase.vue';
import CampoDataBase from '@/components/v2/base/CampoDataBase/CampoDataBase.vue';
import CampoMoneyBase from '@/components/v2/base/CampoMoneyBase/CampoMoneyBase.vue';

const props = defineProps({
    dado: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: true },
});

const osMaeLabel = computed(() => {
    const osMaeObj = props?.dado?.osMae && typeof props.dado.osMae === 'object' ? props.dado.osMae : {};
    return osMaeObj?.codigo || props?.dado?.osMaeCodigo || '';
});

const mostrarOsMae = computed(() => String(osMaeLabel.value || '').trim() !== '');
</script>

<template>
    <CartaoBase>
        <template #header>
            <span class="text-subtitle-1 font-weight-bold">Dados Principais</span>
        </template>

        <template #body>
            <v-row dense class="c-row">
                <v-col cols="12" md="3">
                    <CampoTextoBase label="Código" :value="dado?.codigo" disabled />
                </v-col>
                <v-col cols="12" md="9">
                    <CampoTextoBase label="Descrição" :value="dado?.descricao" disabled />
                </v-col>
                <v-col cols="12" md="3">
                    <CampoTextoBase label="Tipo" :value="dado?.osTipo" disabled />
                </v-col>
                <v-col cols="12" md="3">
                    <CampoTextoBase label="Job" :value="dado?.jobCodigo" disabled />
                </v-col>
                <v-col cols="12" md="3">
                    <CampoTextoBase label="Job Item" :value="dado?.jobItemSequencia" disabled />
                </v-col>
                <v-col v-if="mostrarOsMae" cols="12" md="3">
                    <CampoTextoBase label="OS Mãe" :value="osMaeLabel" disabled />
                </v-col>
                <v-col cols="12" md="4">
                    <CampoTextoBase label="Coordenador" :value="dado?.coordenadorDeProjetosNome" disabled />
                </v-col>
                <v-col cols="12" md="2">
                    <CampoTextoBase label="Quantidade" :value="dado?.osQuantidade" disabled />
                </v-col>
                <v-col cols="12" md="3">
                    <CampoMoneyBase label="Valor Disponível" :value="dado?.valorDisponivel" disabled />
                </v-col>
                <v-col cols="12" md="3">
                    <CampoDataBase label="Data Solicitação" :value="dado?.dataSolicitacao" disabled />
                </v-col>
            </v-row>
        </template>
    </CartaoBase>
</template>

<style scoped>
.c-row {
    margin: 0 !important;
}
</style>
